<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <UserForm
          title="Nastavení mého profilu"
          v-model="dealer"
          @save="save"
          :userAdd="false"
          @certificateChanged="fileUpload"
          :loading="loading"
        >
          <v-col cols="6" class="pt-0 pb-6" v-if="dealer.certificate">
            <h4>
              Sériové číslo certifikátu
            </h4>

            <h2>
              {{ dealer.certificate.serialNumber }}
            </h2>
          </v-col>

          <v-col cols="6" class="pt-0 pb-6" v-if="dealer.certificate">
            <h4>
              Certifikační autorita
            </h4>

            <h2>
              {{ dealer.certificate.authority }}
            </h2>
          </v-col>
        </UserForm>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import UserForm from '@/components/forms/UserForm.vue';
import { SUCCESS_MESSAGES } from '@/enums/success-messages';

export default {
  name: 'UserEdit',
  components: {
    UserForm,
  },
  data() {
    return {
      dealer: {},
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      getDealer: 'users/getDealer',
      updateDealerAndUploadDealerCertificate:
        'users/updateDealerAndUploadDealerCertificate',
    }),
    loadDealer(id) {
      this.getDealer(id).then((response) => {
        this.dealer = response.data;
      });
    },
    save(dealer) {
      this.loading = true;
      this.updateDealerAndUploadDealerCertificate(dealer)
        .then((response) => {
          if (response.status === 200) {
            this.$notify.success({
              title: SUCCESS_MESSAGES.userEditSaveSuccessMessage(
                response.data.firstName,
                response.data.lastName,
              ),
              showClose: true,
              type: 'success',
            });
          }
        }).finally(() => {
          this.loading = false;
        });
    },
    fileUpload(event) {
      this.dealer.certificateFile = event;
    },
  },
  created() {
    const store = JSON.parse(localStorage.getItem('store'));
    if (store) {
      this.loadDealer(store.user.principal.id);
    }
  },
};
</script>
